import React, {Component} from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import padding from "@irati/ui/src/global/padding"
import id from "@irati/utils/id"
import {label3} from "@irati/ui/src/Labels/css/labels"
import {greys} from "@irati/ui/src/global/colors"

import {Image} from "../../ui/Image"
import {Para} from "../../ui/Labels"
import {IconTooltip} from "../../ui/Tooltip"


const Category = styled.div`
  ${label3}
  color: ${greys.medium};
  margin-bottom: 5px;
`

const ImageTitleContainer = styled.div`
  display: flex;
  flex-direction:row;
  align-items: flex-start;
`

const TitleTooltipGroup = styled.div`
  display: flex;
  align-items: flex-end;

  > *:nth-child(2) {
    margin-left: 5px;
    padding-bottom: 3px;
  }

  ${({isRightAligned}) => isRightAligned && `
    justify-content: flex-end;
  `}
`

const StyledImage = styled(Image)`
  margin-right: ${padding.tiny};
`
const Wrapper = styled.div`
  display: flex;
`

class CategoryTitle extends Component {
  static propTypes = {
    category: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    tooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    tooltipPlacement: PropTypes.oneOf([
      "top", "left", "right", "bottom"
    ]),
    children: PropTypes.node,
    className: PropTypes.string,
    icon: PropTypes.node,
    isRightAligned: PropTypes.bool
  }
  static defaultProps = {
    children: null,
    tooltip: null,
    tooltipPlacement: "right",
    className: null,
    icon: null,
    isRightAligned: false
  }


  render() {
    const idNamespace = id("CategoryTitle", this.props)
    const {children, className, title, tooltip, icon, isRightAligned, category, tooltipPlacement} = this.props

    return (
      <Wrapper id={idNamespace} className={className}>
        <ImageTitleContainer>
          {icon && <StyledImage src={icon} alt="" size={45} />}
          <div>
            <Category id={id("category", idNamespace)} uppercase bold>{category}</Category>
            {title && (
              <TitleTooltipGroup isRightAligned={isRightAligned}>
                <Para id={id("title", idNamespace)} large bold flush>{title}</Para>
                {tooltip && <IconTooltip id={idNamespace} placement={tooltipPlacement}>{tooltip}</IconTooltip>}
                {children}
              </TitleTooltipGroup>
            )}
          </div>
        </ImageTitleContainer>
      </Wrapper>
    )
  }
}

export default CategoryTitle
